import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import TransomConfigurator from './../TransomConfigurator'
import Toggle from '../Toggle'
import { withTranslation, Trans } from 'react-i18next'
import { view04ImageOptions } from './views/view04'

class X46BathingPlatform extends Component {
  constructor (props) {
    super(props)
    this.handleTeakOnBathingPlatformChange =
      this.handleTeakOnBathingPlatformChange.bind(this)
    this.handleBathingPlatformChange =
      this.handleBathingPlatformChange.bind(this)
  }

  handleBathingPlatformChange (event) {
    let configuration = this.props.configuration
    configuration.BathingPlatform = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleTeakOnBathingPlatformChange (event) {
    let configuration = this.props.configuration
    configuration.TeakOnBathingPlatform = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = view04ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.086923, 0.012747, 0, -7.9e-5, 0.016342, 0.163327, 0, 2.4e-5, 0, 0,
          1, 0, 346.090565, 214.633395, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Bathing platform' />
          </h1>

          <p>
            <Trans
              defaults='The X4<sup>6</sup> features an optional bathing platform which is operated electrically, integrated attachment for “hang on” bathing ladder with {{wood}} steps.'
              values={{
                wood:
                  this.props.configuration.Deck.value === 1
                    ? ' teak'
                    : 'flexiteek'
              }}
            />
          </p>

          <Toggle
            checked={this.props.configuration.BathingPlatform.value === 2}
            onChange={this.handleBathingPlatformChange}
          >
            <Trans defaults='Bathing platform' />
          </Toggle>

          {this.props.configuration.BathingPlatform.value === 2 ? (
            <Toggle
              checked={
                this.props.configuration.TeakOnBathingPlatform.value === 2
              }
              onChange={this.handleTeakOnBathingPlatformChange}
            >
              <Trans
                defaults='{{wood}} on bathing platform'
                values={{
                  wood:
                    this.props.configuration.Deck.value === 1
                      ? 'Teak'
                      : 'Flexiteek'
                }}
              />
            </Toggle>
          ) : null}
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46BathingPlatform)



// WEBPACK FOOTER //
// ./src/X46/X46BathingPlatform.js